// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //
import DashboardIcon from '@mui/icons-material/Dashboard'
import { BiBarChartSquare } from 'react-icons/bi'
import { RiHome3Line } from 'react-icons/ri'
// this is menu items
import { IoWalletOutline } from 'react-icons/io5'

const pages = {
  id: 'pages',
  type: 'group',
  children: [
    {
      id: 'menu-dashboard',
      title: 'Dashboard',
      type: 'item',
      icon: <RiHome3Line />,
      url: '/dashboard',
      breadcrumbs: false,
      subRoutes: ['/dashboard']
    },

    {
      id: 'menu-campaigns',
      title: 'Campaigns',
      type: 'item',
      url: '/campaigns',
      icon: <BiBarChartSquare />,
      breadcrumbs: false,
      subRoutes: ['/campaigns', '/detail-campaign', '/view-analytics', '/add-campaigns', '/add-campaigns-from-existing', '/edit-campaign']
    },
    {
      id: 'menu-gallery',
      title: 'Creative Gallery',
      type: 'item',
      url: '/creative-gallery',
      icon: <DashboardIcon />,
      breadcrumbs: false,
      subRoutes: ['/creative-gallery']
    },
    {
      id: 'menu-balance',
      title: 'Balance',
      type: 'item',
      url: '/balance',
      icon: <IoWalletOutline />,
      breadcrumbs: false,
      subRoutes: ['/balance']
    }
  ]
}

export default pages
